export const createCustomPage = `mutation CreateCustomPage($input: CreateCustomPageInput!) {
    createCustomPage(input: $input) {
      id
      active
      companyId
      content
      dateCreated
      hideFromHeader
      pageNumber
      title
      userId
    }
  }
  `;
